module.exports = __webpack_public_path__ + "static/media/Galleria - DK Grey_Peri - DK Grey.1c040cd3.jpg";